import convert from "convert-units";
import {
  coins_units,
  units,
  units_1,
  units_2,
  units_4,
  units_7,
} from "../constants.js";
import { convertUnits, DATA } from "./convert.js";
import { convertEnergy2 } from "./convertEnergy.js";
import {
  convertCurrency,
  sumConvertedSync,
  sumSameUnit,
} from "./convertCoin.js";

export const energyCodes = {
  // Electricidad estándar
  electricity_standard_combined: "En1", // Electricidad estándar Combinada
  electricity_standard_domestic: "En2", // Electricidad estándar Doméstico
  electricity_standard_production: "En3", // Electricidad estándar Producción
  electricity_cost_total: "En4", // Costo electricidad

  // Energías Renovables PPA
  renewable_energies_ppa_combined: "En5", // Energías Renovables (PPA) Combinada
  renewable_energies_ppa_domestic: "En6", // Energías Renovables (PPA) Doméstico
  renewable_energies_ppa_production: "En7", // Energías Renovables (PPA) Producción
  renewable_energies_ppa_cost: "En8", // Costo Electricidad Renovables PPA

  // Energías renovables producidas en el sitio
  renewable_energies_on_site_combined: "En9", // Energías renovables producidas en el sitio Combinada
  renewable_energies_on_site_domestic: "En10", // Energías renovables producidas en el sitio Doméstico
  renewable_energies_on_site_production: "En11", // Energías renovables producidas en el sitio Producción
  renewable_energies_on_site_maintenance_and_amortization: "En12", // Amortización y Mantenimiento Energías renovables en el sitio

  // Gas Natural
  natural_gas_combined: "En13", // Gas Natural Combinado (Doméstico / Producción)
  natural_gas_cogeneration: "En14", // Gas Natural - Cogeneración de Energía Eléctrica
  natural_gas_production_operations: "En15", // Gas Natural - Producción y Operaciones
  natural_gas_domestic: "En16", // Gas Natural - Doméstico
  natural_gas_total_cost: "En17", // Costo Gas Natural

  // GLP
  glp_combined: "En18", // GLP (gas licuado de petróleo) Combinada
  glp_cogeneration: "En19", // GLP - Cogeneración de Energía Eléctrica
  glp_production_operations: "En20", // GLP - Producción y Operaciones
  glp_domestic: "En21", // GLP - Doméstico
  glp_total_cost: "En22", // Costo del GLP

  // Heavy Fuel Oil
  heavy_fuel_oil_total: "En23", // Heavy Fuel Oil (aceite combustible pesado)
  heavy_fuel_oil_total_cost: "En24", // Costo del Heavy Fuel Oil (aceite combustible pesado)

  // Light Fuel Oil
  light_fuel_oil_total: "En25", // Light Fuel Oil (aceite combustible)
  light_fuel_oil_total_cost: "En26", // Costo del Light Fuel Oil (aceite combustible)

  // Carbón
  coal_total: "En27", // Carbón
  coal_total_cost: "En28", // Costo del carbón

  // Diesel
  diesel_combined: "En29", // Diesel combinado
  diesel_cogeneration: "En30", // Diesel - Cogeneración de Energía Eléctrica
  diesel_production_operations: "En31", // Diesel - Producción y Operaciones
  diesel_forklifts: "En32", // Diesel - Autoelevadores
  diesel_total_cost: "En33", // Costo del Diesel

  // Biodiesel
  biodiesel_combined: "En34", // Biodiesel combinado
  biodiesel_cogeneration: "En35", // Biodiesel - Cogeneración de Energía Eléctrica
  biodiesel_production_operations: "En36", // Biodiesel - Producción y Operaciones
  biodiesel_forklifts: "En37", // Biodiesel - Autoelevadores
  biodiesel_total_cost: "En38", // Costo del Biodiesel

  // Gasolina / Fuel Oil
  gasoline_combined: "En39", // Gasolina/Fuel Oil combinado
  gasoline_cogeneration: "En40", // Gasolina/Fuel Oil - Cogeneración de Energía Eléctrica
  gasoline_production_operations: "En41", // Gasolina/Fuel Oil - Producción y Operaciones
  gasoline_forklifts: "En42", // Gasolina/Fuel Oil - Autoelevadores
  gasoline_total_cost: "En43", // Costo de Gasolina/Fuel Oil

  // Biocombustible
  biofuel_combined: "En44", // Bio combustible combinado
  biofuel_cogeneration: "En45", // Bio combustible - Cogeneración de Energía Eléctrica
  biofuel_production_operations: "En46", // Bio combustible - Producción y Operaciones
  biofuel_forklifts: "En47", // Bio combustible - Autoelevadores
  biofuel_total_cost: "En48", // Costo del Biocombustible

  // Biomasa
  biomass_total: "En49", // Biomasa
  biomass_total_cost: "En50", // Costo de Biomasa

  // Vapor
  steam_total: "En51", // Vapor
  steam_total_cost: "En52", // Costo del vapor

  // NUEVOS CAMPOS AGREGADOS - Porcentajes renovables y certificados IREC
  biodiesel_renewable_percentage: "En53", // Porcentaje renovable del biodiesel
  gasoline_renewable_percentage: "En54", // Porcentaje renovable de gasolina/fuel oil
  irec_certificates: "En55", // Certificados IREC (International Renewable Energy Certificates)
};

//Codigos de los indicadores que se ven en el dashboard
export const energyKPIsCodes = {
  electricity_standard_combined_kpis: "KPIene1", // Electricidad estándar combinada / unidad
  electricity_standard_domestic_kpis: "KPIene2", // Electricidad standard Domestico / empleado
  electricity_standard_production_kpis: "KPIene3", // Electricidad standard Producción / unidad

  renewable_energies_ppa_combined_kpis: "KPIene4", // Energías Renovables PPA combinada / unidad
  renewable_energies_ppa_domestic_kpis: "KPIene5", // Energías Renovables PPA Domestico / empleado
  renewable_energies_ppa_production_kpis: "KPIene6", // Energías Renovables PPA Producción / unidad

  renewable_energies_on_site_combined_kpis: "KPIene7", // Energías renovables producidas en el sitio Combinada / unidad
  renewable_energies_on_site_domestic_kpis: "KPIene8", // Energías renovables producidas en el sitio Domestico / empleado
  renewable_energies_on_site_production_kpis: "KPIene9", // Energías renovables producidas en el sitio Producción / unidad

  natural_gas_combined_kpis: "KPIene10", // Gas Natural Combinado / unidad
  natural_gas_production_operations_kpis: "KPIene11", // Gas Natural - Producción / unidad
  natural_gas_domestic_kpis: "KPIene12", // Gas Natural Domestico / empleado
  natural_gas_cogeneration_kpis: "KPIene13", // Gas Natural - Cogeneración de Energía Electrica / unidad

  glp_combined_kpis: "KPIene14", // GLP (gas licuado de petróleo) combinado / unidad
  glp_production_operations_kpis: "KPIene15", // GLP Producción / unidad
  glp_domestic_kpis: "KPIene16", // GLP Domestico / empleado
  glp_cogeneration_kpis: "KPIene17", // GLP - Cogeneración de Energía Electrica / unidad

  heavy_fuel_oil_total_kpis: "KPIene18", // Heavy Fuel Oil (aceite combustible pesado) / unidad
  light_fuel_oil_total_kpis: "KPIene19", // Light fuel oil (aceite combustible) / unidad
  coal_total_kpis: "KPIene20", // Carbón / unidad

  diesel_combined_kpis: "KPIene21", // Diesel Combinado / unidad
  diesel_production_operations_kpis: "KPIene22", // Diesel - Producción y Operaciones / unidad
  diesel_forklifts_kpis: "KPIene23", // Diesel - Autoelevadores / unidad
  diesel_cogeneration_kpis: "KPIene24", // Diesel - Cogeneración de Energía Electrica / unidad

  biodiesel_combined_kpis: "KPIene25", // Biodiesel Combinado / unidad
  biodiesel_production_operations_kpis: "KPIene26", // Biodiesel - Producción y Operaciones / unidad
  biodiesel_forklifts_kpis: "KPIene27", // Biodiesel - Autoelevadores / unidad
  biodiesel_cogeneration_kpis: "KPIene28", // Biodiesel - Cogeneración de Energía Electrica / unidad

  gasoline_combined_kpis: "KPIene29", // Gasolina/Fuel Oil Combinado / unidad
  gasoline_production_operations_kpis: "KPIene30", // Gasolina - Producción y Operaciones / unidad
  gasoline_forklifts_kpis: "KPIene31", // Gasolina Autoelevadores / unidad
  gasoline_cogeneration_kpis: "KPIene32", // Gasolina - Cogeneración de Energía Electrica / unidad

  biofuel_combined_kpis: "KPIene33", // Biocombustible (Etanol) combinada / unidad
  biofuel_production_operations_kpis: "KPIene34", // Biocombustible (Etanol) - Producción y Operaciones / unidad
  biofuel_forklifts_kpis: "KPIene35", // BioGasolina (Etanol)- Autoelevadores / unidad
  biofuel_cogeneration_kpis: "KPIene36", // Biocombustible (Etanol) - Cogeneración de Energía Electrica / unidad

  biomass_total_kpis: "KPIene37", // Biomasa / unidad
  steam_total_kpis: "KPIene38", // Vapor / unidad
  //total_energy_kpis: "KPIene39", // Energía Total / unidad
  total_energy_consumption_kpis: "KPIene39", // Energía Total
  total_energy_kpis: "KPIene40", // Energía Total / unidad
  total_energy_cost_consumption_kpis: "KPIene41", // Costo energía total
  energy_cost_kpis: "KPIene42", // Costo energia/ unidad

  renewable_energy_percentage_kpis: "KPIene43", // % Energías Renovables
  non_renewable_energy_percentage_kpis: "KPIene44", // % Energías No Renovables
  renewable_with_irec_percentage_kpis: "KPIene45", // % Energías Renovables con IREC

  // Nuevos KPIs de Desempeño Energético
  total_electricity_kpis: "KPIene46", // Energía Eléctrica Total
  total_electricity_cost_kpis: "KPIene47", // Costo energía eléctrica total
  electricity_per_unit_kpis: "KPIene48", // Energía eléctrica / unidad
  electricity_cost_per_unit_kpis: "KPIene49", // Costo energía eléctrica / unidad

  total_fuels_kpis: "KPIene50", // Combustibles total
  total_fuels_cost_kpis: "KPIene51", // Costo combustible total
  fuels_per_unit_kpis: "KPIene52", //  ACTUALIZADO>> Costo combustible / unidad (antes era consumo)
};

//En base al valor del campo / key devuelve el valor correspondiente de acuerdo al año es de tipo {total, unit}
// Convierte y suma los valores de un array de KPIs asegurando la misma unidad
function addData2(kpisArray, unitSelected) {
  let suma = 0;
  for (let kpi of kpisArray) {
    //console.log(kpisArray)
    if (!kpi) continue;
    suma +=
      convertEnergy2(kpi.total, kpi.unit, unitSelected, kpi.source, true) || 0;
  }
  return suma;
}

// Devuelve el KPI solicitado en formato { total, unit }
export function energyFormulasIndicators(
  field,
  year,
  data,
  baseline,
  employees,
) {
  const getKPI = (key, divisor = 1) => ({
    total: (data[key]?.[year].total || 0) / divisor,
    unit: data[key]?.[year].unit,
  });

  switch (field) {
    // ELECTRICIDAD
    case "electricity_standard_combined_kpis":
      return getKPI("electricity_standard_combined", baseline);
    case "electricity_standard_domestic_kpis":
      return getKPI("electricity_standard_domestic", employees);
    case "electricity_standard_production_kpis":
      return getKPI("electricity_standard_production", baseline);

    // ENERGÍAS RENOVABLES PPA
    case "renewable_energies_ppa_combined_kpis":
      return getKPI("renewable_energies_ppa_combined", baseline);
    case "renewable_energies_ppa_domestic_kpis":
      return getKPI("renewable_energies_ppa_domestic", employees);
    case "renewable_energies_ppa_production_kpis":
      return getKPI("renewable_energies_ppa_production", baseline);

    // ENERGÍAS RENOVABLES ON SITE
    case "renewable_energies_on_site_combined_kpis":
      return getKPI("renewable_energies_on_site_combined", baseline);
    case "renewable_energies_on_site_domestic_kpis":
      return getKPI("renewable_energies_on_site_domestic", employees);
    case "renewable_energies_on_site_production_kpis":
      return getKPI("renewable_energies_on_site_production", baseline);

    // GAS NATURAL
    case "natural_gas_combined_kpis":
      return getKPI("natural_gas_combined", baseline);
    case "natural_gas_cogeneration_kpis":
      return getKPI("natural_gas_cogeneration", baseline);
    case "natural_gas_production_operations_kpis":
      return getKPI("natural_gas_production_operations", baseline);
    case "natural_gas_domestic_kpis":
      return getKPI("natural_gas_domestic", employees);

    // GLP
    case "glp_combined_kpis":
      return getKPI("glp_combined", baseline);
    case "glp_cogeneration_kpis":
      return getKPI("glp_cogeneration", baseline);
    case "glp_production_operations_kpis":
      return getKPI("glp_production_operations", baseline);
    case "glp_domestic_kpis":
      return getKPI("glp_domestic", employees);

    // COMBUSTIBLES FÓSILES
    case "heavy_fuel_oil_total_kpis":
      return getKPI("heavy_fuel_oil_total", baseline);
    case "light_fuel_oil_total_kpis":
      return getKPI("light_fuel_oil_total", baseline);
    case "coal_total_kpis":
      return getKPI("coal_total", baseline);

    // DIESEL
    case "diesel_combined_kpis":
      return getKPI("diesel_combined", baseline);
    case "diesel_cogeneration_kpis":
      return getKPI("diesel_cogeneration", baseline);
    case "diesel_production_operations_kpis":
      return getKPI("diesel_production_operations", baseline);
    case "diesel_forklifts_kpis":
      return getKPI("diesel_forklifts", baseline);

    // BIODIESEL
    case "biodiesel_combined_kpis":
      return getKPI("biodiesel_combined", baseline);
    case "biodiesel_cogeneration_kpis":
      return getKPI("biodiesel_cogeneration", baseline);
    case "biodiesel_production_operations_kpis":
      return getKPI("biodiesel_production_operations", baseline);
    case "biodiesel_forklifts_kpis":
      return getKPI("biodiesel_forklifts", baseline);

    // GASOLINA
    case "gasoline_combined_kpis":
      return getKPI("gasoline_combined", baseline);
    case "gasoline_cogeneration_kpis":
      return getKPI("gasoline_cogeneration", baseline);
    case "gasoline_production_operations_kpis":
      return getKPI("gasoline_production_operations", baseline);
    case "gasoline_forklifts_kpis":
      return getKPI("gasoline_forklifts", baseline);

    // BIOFUEL
    case "biofuel_combined_kpis":
      return getKPI("biofuel_combined", baseline);
    case "biofuel_cogeneration_kpis":
      return getKPI("biofuel_cogeneration", baseline);
    case "biofuel_production_operations_kpis":
      return getKPI("biofuel_production_operations", baseline);
    case "biofuel_forklifts_kpis":
      return getKPI("biofuel_forklifts", baseline);

    // OTROS
    case "biomass_total_kpis":
      return getKPI("biomass_total", baseline);
    case "steam_total_kpis":
      return getKPI("steam_total", baseline);

    // NUEVOS KPIs AGREGADOS - Porcentajes renovables y certificados IREC
    case "biodiesel_renewable_percentage_kpis":
      return getKPI("biodiesel_renewable_percentage", baseline);
    case "gasoline_renewable_percentage_kpis":
      return getKPI("gasoline_renewable_percentage", baseline);
    case "irec_certificates_kpis":
      // return getKPI("irec_certificates", baseline);
      return {
        total: data["irec_certificates"]?.[year].total,
        unit: data["irec_certificates"]?.[year].unit,
      };

    // SUMA DE ENERGÍA TOTAL ene1, ene2 y ene3
    // case "total_energy_kpis": {
    //   // Verificar si existen Ene2 domestic y Ene3 production
    //   const ene2Domestic = energyFormulasIndicators(
    //     "electricity_standard_domestic_kpis",
    //     year,
    //     data,
    //     baseline,
    //     employees
    //   );
    //   const ene3Production = energyFormulasIndicators(
    //     "electricity_standard_production_kpis",
    //     year,
    //     data,
    //     baseline,
    //     employees
    //   );

    //   // Si ambos tienen valores > 0, usar Ene2 + Ene3
    //   const hasRenewableData =
    //     (ene2Domestic?.total || 0) > 0 && (ene3Production?.total || 0) > 0;

    //   let totalEnergyKeys;
    //   if (hasRenewableData) {
    //     // Usar Ene2 domestic + Ene3 production
    //     totalEnergyKeys = [
    //       "electricity_standard_domestic_kpis",
    //       "electricity_standard_production_kpis",
    //     ];
    //   } else {
    //     // Usar solo Ene1 combined
    //     totalEnergyKeys = ["electricity_standard_combined_kpis"];
    //   }

    //   const kpisData = totalEnergyKeys.map((key) => ({
    //     key,
    //     result: energyFormulasIndicators(key, year, data, baseline, employees),
    //   }));

    //   // --- Crear un resumen por fuente ---
    //   const breakdown = kpisData.map((item) => ({
    //     source: item.key,
    //     total: item.result.total,
    //     unit: item.result.unit,
    //   }));

    //   //  IMPORTANTE: No convertir unidades aquí porque son intensidades (kWh/unidad)
    //   // Los KPIs ya están divididos por baseline, entonces sumar directamente
    //   const totalSum = breakdown.reduce((sum, item) => sum + (item.total || 0), 0);
    //   const firstUnit = breakdown[0]?.unit || "kWh";

    //   return {
    //     total: totalSum,
    //     unit: firstUnit,
    //   };
    // }
    case "total_energy_kpis": {
      const result = energyFormulasIndicators(
        "total_energy_consumption_kpis", // KPIene39
        year,
        data,
        baseline,
        employees,
      );

      const unit = result.unit;
      const safeBaseline = baseline || 1;

      return {
        total: result.total / safeBaseline,
        unit,
      };
    }

    // KPIene40: COSTO DE ENERGÍA / UNIDAD
    //  ACTUALIZADO: Corregido typo, quitado vapor, agregados costos faltantes segun entendi nuevo revision
    case "energy_cost_kpis": {
      //  CÓDIGO ANTERIOR (tenía typo, incluía vapor, faltaban costos):
      // const costKeys = [
      //   "electricity_cost_total",
      //   "renewable_eneries_ppa_cost",  // ← Typo
      //   "renewable_energies_on_site_maintenance_and_amortization",
      //   "natural_gas_total_cost",
      //   "glp_total_cost",
      //   "diesel_total_cost",
      //   "biodiesel_total_cost",
      //   "gasoline_total_cost",
      //   "biomass_total_cost",
      //   "steam_total_cost",  //
      // ];

      //  NUEVA FÓRMULA: Usa KPIene45 (Electricidad) + KPIene49 (Combustibles)
      const totalElectricityCost = energyFormulasIndicators(
        "total_electricity_cost_kpis", // KPIene45
        year,
        data,
        baseline,
        employees,
      );

      const totalFuelsCost = energyFormulasIndicators(
        "total_fuels_cost_kpis", // KPIene49
        year,
        data,
        baseline,
        employees,
      );

      const totalCost =
        (totalElectricityCost.total || 0) + (totalFuelsCost.total || 0);
      const unit = totalElectricityCost.unit || totalFuelsCost.unit;
      const safeBaseline = baseline || 1;

      return {
        total: totalCost / safeBaseline,
        unit,
      };
    }

    // KPIene41: % ENERGÍAS RENOVABLES (sin IREC)
    // Fórmula: (Renovables Directos + Biodiesel Renovable + Gasolina Renovable) / Total Energía × 100
    //  case "renewable_energy_percentage_kpis": {

    //   /* ---------------- Renovables directos ---------------- */
    //   const directRenewableKeys = [
    //     "renewable_energies_ppa_combined",
    //     "renewable_energies_ppa_domestic",
    //     "renewable_energies_ppa_production",
    //     "renewable_energies_on_site_combined",
    //     "renewable_energies_on_site_domestic",
    //     "renewable_energies_on_site_production",
    //     //"biomass_total",
    //   ];

    //   const directRenewableBreakdown = directRenewableKeys.map(key => ({
    //     source: key,
    //     total: data?.[key]?.[year]?.total || 0,
    //     unit: data?.[key]?.[year]?.unit || "",
    //   }));

    //   const totalDirectRenewables = addData2(directRenewableBreakdown, "MWh");

    //   /* ---------------- Biodiesel renovable ---------------- */
    //   const biodieselKeys = [
    //     "biodiesel_combined",
    //     "biodiesel_cogeneration",
    //     "biodiesel_production_operations",
    //     "biodiesel_forklifts",
    //   ];

    //   const biodieselBreakdown = biodieselKeys.map(key => ({
    //     source: key,
    //     total: data?.[key]?.[year]?.total || 0,
    //     unit: data?.[key]?.[year]?.unit || "",
    //   }));

    //   const totalBiodiesel = addData2(biodieselBreakdown, "MWh");

    //   const biodieselPercentage =
    //     getKPI("biodiesel_renewable_percentage", baseline, year, data)?.total || 0;

    //   const biodieselRenewable = (totalBiodiesel * biodieselPercentage) / 100;

    //   /* ---------------- Gasolina renovable ---------------- */
    //   const gasolineKeys = [
    //     "gasoline_combined",
    //     "gasoline_cogeneration",
    //     "gasoline_production_operations",
    //     "gasoline_forklifts",
    //   ];

    //   const gasolineBreakdown = gasolineKeys.map(key => ({
    //     source: key,
    //     total: data?.[key]?.[year]?.total || 0,
    //     unit: data?.[key]?.[year]?.unit || "",
    //   }));

    //   const totalGasoline = addData2(gasolineBreakdown, "MWh");

    //   const gasolinePercentage =
    //     getKPI("gasoline_renewable_percentage", baseline, year, data)?.total || 0;

    //   const gasolineRenewable = (totalGasoline * gasolinePercentage) / 100;

    //   /* ---------------- Total renovables (sin IREC) ---------------- */
    //   const totalRenewable =
    //     totalDirectRenewables + biodieselRenewable + gasolineRenewable;

    //   /* ---------------- Total energía general ---------------- */
    //   const totalEnergy = energyFormulasIndicators( "total_energy_consumption_kpis", year, data, baseline, employees )?.total ?? 0;

    //   /* ---------------- Porcentaje ---------------- */
    //   const percentage =
    //     totalEnergy > 0 ? (totalRenewable  / totalEnergy) * 100 : 0;
    //   return {
    //     total: percentage,
    //     unit: "%",
    //     breakdown: [
    //       ...directRenewableBreakdown,
    //       ...biodieselBreakdown,
    //       ...gasolineBreakdown,
    //     ],
    //   };
    // }

    case "renewable_energy_percentage_kpis": {
      /* ---------------- Renovables directos ---------------- */
      const directRenewableKeys = [
        "renewable_energies_ppa_combined",
        "renewable_energies_ppa_domestic",
        "renewable_energies_ppa_production",
        "renewable_energies_on_site_combined",
        "renewable_energies_on_site_domestic",
        "renewable_energies_on_site_production",
      ];

      const directRenewableBreakdown = directRenewableKeys.map((key) => ({
        source: key,
        total: data?.[key]?.[year]?.total || 0,
        unit: data?.[key]?.[year]?.unit || "",
      }));

      const totalDirectRenewables = addData2(directRenewableBreakdown, "MWh");

      /* ---------------- No renovables (ENE) ---------------- */
      /* ---------------- No renovables ENE (electricidad estándar) ---------------- */
      const noRenewableKeys = [
        "electricity_standard_combined",
        "electricity_standard_domestic",
        "electricity_standard_production",
      ];

      const noRenewableBreakdown = noRenewableKeys.map((key) => ({
        source: key,
        total: data?.[key]?.[year]?.total || 0,
        unit: data?.[key]?.[year]?.unit || "",
      }));

      const totalNonRenewables = addData2(noRenewableBreakdown, "MWh");

      /* ---------------- IREC ---------------- */
      const irecData = data["irec_certificates"]?.[year]?.total ?? 0;
      const totalIREC =
        convertEnergy2(
          irecData?.total || 0,
          irecData?.unit,
          "MWh",
          "irec_certificates",
          false,
        ) || 0;
      /* ---------------- Total ENE ---------------- */
      const totalENE = totalDirectRenewables + totalNonRenewables + totalIREC;

      /* ---------------- Porcentaje ---------------- */
      const percentage =
        totalENE > 0 ? (totalDirectRenewables / totalENE) * 100 : 0;

      return {
        total: percentage,
        unit: "%",
        breakdown: directRenewableBreakdown,
      };
    }

    //     case "non_renewable_energy_percentage_kpis": {
    //   const renewableResult = energyFormulasIndicators(
    //     "renewable_energy_percentage_kpis",
    //     year,
    //     data,
    //     baseline,
    //     employees
    //   );

    //   const renewable = renewableResult?.total;

    //   // Si no hay dato de renovables, no podemos inferir no renovable
    //   if (typeof renewable !== "number" || isNaN(renewable)) {
    //     return {
    //       total: 0,
    //       unit: "%",
    //     };
    //   }

    //   return {
    //     total: Math.max(0, 100 - renewable),
    //     unit: "%",
    //   };
    // }
    case "non_renewable_energy_percentage_kpis": {
      /* ---------------- No renovables ENE (electricidad estándar) ---------------- */
      const noRenewableKeys = [
        "electricity_standard_combined",
        "electricity_standard_domestic",
        "electricity_standard_production",
      ];

      const noRenewableBreakdown = noRenewableKeys.map((key) => ({
        source: key,
        total: data?.[key]?.[year]?.total || 0,
        unit: data?.[key]?.[year]?.unit || "",
      }));

      const totalNoRenewablesRaw = addData2(noRenewableBreakdown, "MWh");

      /* ---------------- IREC ---------------- */
      const irecData = data?.["irec_certificates"]?.[year];
      const totalIREC =
        convertEnergy2(
          irecData?.total || 0,
          irecData?.unit,
          "MWh",
          "irec_certificates",
          false,
        ) || 0;

      /* ---------------- No renovable ENE (final) ---------------- */
      const totalNoRenewablesENE = Math.max(
        0,
        totalNoRenewablesRaw - totalIREC,
      );

      /* ---------------- Renovables directos ---------------- */
      const directRenewableKeys = [
        "renewable_energies_ppa_combined",
        "renewable_energies_ppa_domestic",
        "renewable_energies_ppa_production",
        "renewable_energies_on_site_combined",
        "renewable_energies_on_site_domestic",
        "renewable_energies_on_site_production",
      ];

      const directRenewableBreakdown = directRenewableKeys.map((key) => ({
        source: key,
        total: data?.[key]?.[year]?.total || 0,
        unit: data?.[key]?.[year]?.unit || "",
      }));

      const totalDirectRenewables = addData2(directRenewableBreakdown, "MWh");

      /* ---------------- Total ENE (Excel) ---------------- */
      const totalENE = totalDirectRenewables + totalNoRenewablesENE + totalIREC;

      /* ---------------- Porcentaje ---------------- */
      const percentage =
        totalENE > 0 ? (totalNoRenewablesENE / totalENE) * 100 : 0;

      return {
        total: percentage,
        unit: "%",
        breakdown: noRenewableBreakdown,
      };
    }

    //  KPIene45: % ENERGÍAS RENOVABLES CON IREC
    // Fórmula: (Renovables Directos + Biodiesel×% + Gasolina×% + IREC) / (KPIene39 + IREC) × 100
    // case "renewable_with_irec_percentage_kpis": {
    //   /* ---------------- Renovables directos (5,6,7,9,10,11,49) ---------------- */
    //   const directRenewableKeys = [
    //     "renewable_energies_ppa_combined",      // En5
    //     "renewable_energies_ppa_domestic",      // En6
    //     "renewable_energies_ppa_production",    // En7
    //     "renewable_energies_on_site_combined",  // En9
    //     "renewable_energies_on_site_domestic",  // En10
    //     "renewable_energies_on_site_production",// En11
    //     "biomass_total",                        // En49
    //   ];

    //   const directRenewableBreakdown = directRenewableKeys.map(key => ({
    //     source: key,
    //     total: data?.[key]?.[year]?.total || 0,
    //     unit: data?.[key]?.[year]?.unit || "",
    //   }));

    //   const totalDirectRenewables = addData2(directRenewableBreakdown, "MWh");

    //   /* ---------------- Biodiesel renovable (34,35,36,37 × %) ---------------- */
    //   const biodieselKeys = [
    //     "biodiesel_combined",           // En34
    //     "biodiesel_cogeneration",       // En35
    //     "biodiesel_production_operations", // En36
    //     "biodiesel_forklifts",          // En37
    //   ];

    //   const biodieselBreakdown = biodieselKeys.map(key => ({
    //     source: key,
    //     total: data?.[key]?.[year]?.total || 0,
    //     unit: data?.[key]?.[year]?.unit || "",
    //   }));

    //   const totalBiodiesel = addData2(biodieselBreakdown, "MWh");
    //   const biodieselPercentage = getKPI("biodiesel_renewable_percentage", baseline, year, data)?.total || 0;
    //   const biodieselRenewable = (totalBiodiesel * biodieselPercentage) / 100;

    //   /* ---------------- Gasolina renovable (39,40,41,42 × %) ---------------- */
    //   const gasolineKeys = [
    //     "gasoline_combined",            // En39
    //     "gasoline_cogeneration",        // En40
    //     "gasoline_production_operations", // En41
    //     "gasoline_forklifts",           // En42
    //   ];

    //   const gasolineBreakdown = gasolineKeys.map(key => ({
    //     source: key,
    //     total: data?.[key]?.[year]?.total || 0,
    //     unit: data?.[key]?.[year]?.unit || "",
    //   }));

    //   const totalGasoline = addData2(gasolineBreakdown, "MWh");
    //   const gasolinePercentage = getKPI("gasoline_renewable_percentage", baseline, year, data)?.total || 0;
    //   const gasolineRenewable = (totalGasoline * gasolinePercentage) / 100;

    //   /* ---------------- IREC Certificates (En55) ---------------- */
    //   const irecData = data?.["irec_certificates"]?.[year];
    //   const irecMWh = convertEnergy2(irecData?.total || 0, irecData?.unit, "MWh", "irec_certificates", false) || 0;

    //   /* ---------------- Total renovables con IREC (numerador) ---------------- */
    //   const totalRenewableWithIrec = totalDirectRenewables + biodieselRenewable + gasolineRenewable + irecMWh;

    //   /* ---------------- Total energía + IREC (denominador) ---------------- */
    //   const totalEnergy = energyFormulasIndicators(
    //     "total_energy_consumption_kpis",
    //     year,
    //     data,
    //     baseline,
    //     employees
    //   )?.total ?? 0;

    //   const denominador = totalEnergy + irecMWh;

    //   /* ---------------- Porcentaje ---------------- */
    //   const percentageWithIrec = denominador > 0 ? (totalRenewableWithIrec * 100) / denominador : 0;

    //   return {
    //     total: percentageWithIrec,
    //     unit: "%",
    //   };
    // }
    case "renewable_with_irec_percentage_kpis": {
      /* ---------------- Renovables directos ---------------- */
      const directRenewableKeys = [
        "renewable_energies_ppa_combined",
        "renewable_energies_ppa_domestic",
        "renewable_energies_ppa_production",
        "renewable_energies_on_site_combined",
        "renewable_energies_on_site_domestic",
        "renewable_energies_on_site_production",
      ];

      const directRenewableBreakdown = directRenewableKeys.map((key) => ({
        source: key,
        total: data?.[key]?.[year]?.total || 0,
        unit: data?.[key]?.[year]?.unit || "",
      }));

      const totalDirectRenewables = addData2(directRenewableBreakdown, "MWh");

      /* ---------------- No renovables ENE (electricidad estándar) ---------------- */
      const noRenewableKeys = [
        "electricity_standard_combined",
        "electricity_standard_domestic",
        "electricity_standard_production",
      ];

      const noRenewableBreakdown = noRenewableKeys.map((key) => ({
        source: key,
        total: data?.[key]?.[year]?.total || 0,
        unit: data?.[key]?.[year]?.unit || "",
      }));

      const totalNoRenewablesRaw = addData2(noRenewableBreakdown, "MWh");

      /* ---------------- IREC ---------------- */
      const irecData = data?.["irec_certificates"]?.[year];
      const irecMWh =
        convertEnergy2(
          irecData?.total || 0,
          irecData?.unit,
          "MWh",
          "irec_certificates",
          false,
        ) || 0;

      const totalNoRenewablesENE = Math.max(0, totalNoRenewablesRaw - irecMWh);

      /* ---------------- Total ENE (misma lógica ENE) ---------------- */
      const totalENE = totalDirectRenewables + totalNoRenewablesENE + irecMWh;

      /* ---------------- KPI Excel: IREC / TOTAL ENE ---------------- */
      const percentage = totalENE > 0 ? (irecMWh / totalENE) * 100 : 0;

      return {
        total: percentage,
        unit: "%",
      };
    }

    // =====================================================
    // NUEVOS KPIs DE DESEMPEÑO ENERGÉTICO
    // =====================================================

    // 1. ENERGÍA ELÉCTRICA TOTAL
    case "total_electricity_kpis": {
      const types = [
        {
          combined: "electricity_standard_combined",
          domestic: "electricity_standard_domestic",
          production: "electricity_standard_production",
        },
        {
          combined: "renewable_energies_ppa_combined",
          domestic: "renewable_energies_ppa_domestic",
          production: "renewable_energies_ppa_production",
        },
        {
          combined: "renewable_energies_on_site_combined",
          domestic: "renewable_energies_on_site_domestic",
          production: "renewable_energies_on_site_production",
        },
      ];

      const electricityData = [];

      types.forEach(({ combined, domestic, production }) => {
        const combinedValue = data[combined]?.[year]?.total || 0;

        if (combinedValue > 0) {
          electricityData.push({
            total: combinedValue,
            unit: data[combined]?.[year]?.unit,
            source: combined,
          });
        } else {
          const domesticValue = data[domestic]?.[year]?.total || 0;
          const productionValue = data[production]?.[year]?.total || 0;

          if (domesticValue > 0) {
            electricityData.push({
              total: domesticValue,
              unit: data[domestic]?.[year]?.unit,
              source: domestic,
            });
          }

          if (productionValue > 0) {
            electricityData.push({
              total: productionValue,
              unit: data[production]?.[year]?.unit,
              source: production,
            });
          }
        }
      });

      return {
        total: addData2(electricityData, "MWh"),
        unit: "MWh",
      };
    }

    // 2. COSTO ENERGÍA ELÉCTRICA TOTAL
    case "total_electricity_cost_kpis": {
      const electricityCostKeys = [
        "electricity_cost_total",
        "renewable_energies_ppa_cost",
        "renewable_energies_on_site_maintenance_and_amortization",
      ];

      const costData = electricityCostKeys.map((key) => ({
        total: data[key]?.[year]?.total || 0,
        unit: data[key]?.[year]?.unit,
      }));

      const unit = costData.find((item) => item.unit)?.unit;

      return {
        total: sumSameUnit(costData, unit).total,
        unit,
      };
    }

    // 3. ENERGÍA ELÉCTRICA / UNIDAD
    case "electricity_per_unit_kpis": {
      const totalElectricity = energyFormulasIndicators(
        "total_electricity_kpis",
        year,
        data,
        baseline,
        employees,
      );

      return {
        total: totalElectricity.total / baseline,
        unit: totalElectricity.unit,
      };
    }

    // 4. COSTO ENERGÍA ELÉCTRICA / UNIDAD
    case "electricity_cost_per_unit_kpis": {
      const totalElectricityCost = energyFormulasIndicators(
        "total_electricity_cost_kpis",
        year,
        data,
        baseline,
        employees,
      );

      return {
        total: totalElectricityCost.total / baseline,
        unit: totalElectricityCost.unit,
      };
    }

    // 5. COMBUSTIBLES TOTAL
    case "total_fuels_kpis": {
      const fuelKeys = [
        "natural_gas_combined", // Ene13
        "natural_gas_cogeneration", // Ene14
        "natural_gas_production_operations", // Ene15
        "natural_gas_domestic", // Ene16
        "glp_combined", // Ene18
        "glp_cogeneration", // Ene19
        "glp_production_operations", // Ene20
        "glp_domestic", // Ene21
        "heavy_fuel_oil_total", // Ene23
        "light_fuel_oil_total", // Ene25
        "coal_total", // Ene27
        "diesel_combined", // Ene29
        "diesel_cogeneration", // Ene30
        "diesel_production_operations", // Ene31
        "diesel_forklifts", // Ene32
        "biodiesel_combined", // Ene34
        "biodiesel_cogeneration", // Ene35
        "biodiesel_production_operations", // Ene36
        "biodiesel_forklifts", // Ene37
        "gasoline_combined", // Ene39
        "gasoline_cogeneration", // Ene40
        "gasoline_production_operations", // Ene41
        "gasoline_forklifts", // Ene42
        "biofuel_combined", // Ene44
        "biofuel_cogeneration", // Ene45
        "biofuel_production_operations", // Ene46
        "biofuel_forklifts", // Ene47
        "biomass_total", // Ene49
        "steam_total",
        //  QUITADO: "steam_total" (Ene51) - El vapor no es combustible
      ];

      const fuelData = fuelKeys.map((key) => ({
        total: data[key]?.[year]?.total || 0,
        unit: data[key]?.[year]?.unit,
        source: key,
      }));

      return {
        total: addData2(fuelData, "MWh"),
        unit: "MWh",
      };
    }

    // 6. COSTO COMBUSTIBLE TOTAL
    case "total_fuels_cost_kpis": {
      const fuelCostKeys = [
        "natural_gas_total_cost", // Ene17
        "glp_total_cost", // Ene22
        "heavy_fuel_oil_total_cost", // Ene24
        "light_fuel_oil_total_cost", // Ene26
        "coal_total_cost", // Ene28
        "diesel_total_cost", // Ene33
        "biodiesel_total_cost", // Ene38
        "gasoline_total_cost", // Ene43
        "biofuel_total_cost", // Ene48
        "biomass_total_cost", // Ene50
        "steam_total_cost",
        // QUITADO: "steam_total_cost" (Ene52) - El vapor no es combustible
      ];

      const costData = fuelCostKeys.map((key) => ({
        total: data[key]?.[year]?.total || 0,
        unit: data[key]?.[year]?.unit,
      }));

      const unit = costData.find((item) => item.unit)?.unit;

      return {
        total: sumSameUnit(costData, unit).total,
        unit,
      };
    }

    // 7. COMBUSTIBLES / UNIDAD (KPIene50)
    // ✅ ACTUALIZADO: Ahora usa COSTO en lugar de CONSUMO
    // Fórmula: Costo combustible total (KPIene49) / VPS
    case "fuels_per_unit_kpis": {
      //  CÓDIGO ANTERIOR (usaba consumo en MWh):
      // const totalFuels = energyFormulasIndicators("total_fuels_kpis", year, data, baseline, employees);
      // return { total: totalFuels.total / baseline, unit: totalFuels.unit };

      // ✅ NUEVA FÓRMULA: Usa costo en lugar de consumo
      const totalFuelsCost = energyFormulasIndicators(
        "total_fuels_kpis", // KPIene49 - Costo combustible total
        year,
        data,
        baseline,
        employees,
      );

      return {
        total: totalFuelsCost.total / baseline,
        unit: totalFuelsCost.unit, // USD/unidad (o moneda configurada)
      };
    }

    //  ELIMINADO: case "fuels_cost_per_unit_kpis" (KPIene53)
    // Era redundante con KPIene50 que ahora usa costo

    // 8. ENERGÍA TOTAL (Electricidad + Combustibles) KPIene51
    case "total_energy_consumption_kpis": {
      const totalElectricity = energyFormulasIndicators(
        "total_electricity_kpis",
        year,
        data,
        baseline,
        employees,
      );

      const totalFuels = energyFormulasIndicators(
        "total_fuels_kpis",
        year,
        data,
        baseline,
        employees,
      );
      return {
        total: totalElectricity.total + totalFuels.total,
        unit: "MWh",
      };
    }

    // 9. KPIene52: COSTO ENERGÍA TOTAL
    //  Basado en la misma lógica que KPIene40, pero sin dividir por baseline
    // Fórmula: KPIene45 (Costo electricidad total) + KPIene49 (Costo combustibles total)
    case "total_energy_cost_consumption_kpis": {
      const totalElectricityCost = energyFormulasIndicators(
        "total_electricity_cost_kpis", // KPIene45
        year,
        data,
        baseline,
        employees,
      );

      const totalFuelsCost = energyFormulasIndicators(
        "total_fuels_cost_kpis", // KPIene49
        year,
        data,
        baseline,
        employees,
      );

      const unit = totalElectricityCost.unit || totalFuelsCost.unit;

      return {
        total: (totalElectricityCost.total || 0) + (totalFuelsCost.total || 0),
        unit,
      };
    }

    default:
      return null;
  }
}

//Determina las unidades utilizadas de acuerdo a cada campo/key ver boceto con unidades
export const determineEnergyUnits = (value) => {
  // 🔹 Agrupamos por tipo de unidad
  const energyGroups = {
    // Energía eléctrica
    units: [
      "electricity_standard_combined_kpis",
      "electricity_standard_combined",
      "electricity_standard_domestic_kpis",
      "electricity_standard_domestic",
      "electricity_standard_production_kpis",
      "electricity_standard_production",
      // Nuevos KPIs de electricidad
      "total_electricity_kpis",
      "electricity_per_unit_kpis",
      "total_energy_consumption_kpis",
    ],

    // Energías renovables (kWh / MWh)
    units_1: [
      "renewable_energies_ppa_combined_kpis",
      "renewable_energies_ppa_combined",
      "renewable_energies_ppa_domestic_kpis",
      "renewable_energies_ppa_domestic",
      "renewable_energies_ppa_production_kpis",
      "renewable_energies_ppa_production",
    ],

    // Gases, vapor, líquidos (Nm³, L, ton, etc.)
    units_2: [
      "natural_gas_combined_kpis",
      "natural_gas_combined",
      "natural_gas_cogeneration_kpis",
      "natural_gas_cogeneration",
      "natural_gas_production_operations_kpis",
      "natural_gas_production_operations",
      "natural_gas_domestic_kpis",
      "natural_gas_domestic",
      "diesel_combined",
      "diesel_cogeneration",
      "diesel_production_operations",
      "diesel_forklifts",
      "biodiesel_combined",
      "biodiesel_cogeneration",
      "biodiesel_production_operations",
      "biodiesel_forklifts",
      "gasoline_combined",
      "gasoline_cogeneration",
      "gasoline_production_operations",
      "gasoline_forklifts",
      "biofuel_combined",
      "biofuel_cogeneration",
      "biofuel_production_operations",
      "biofuel_forklifts",
      "biofuel_forklifts",
      // "biomass_total",
      // "steam_total",
      // Nuevos KPIs de combustibles
      "total_fuels_kpis",
      "fuels_per_unit_kpis",
    ],

    // Carbón
    units_7: ["coal_total", "coal_kpis"],
    units_4: [
      "glp_combined",
      "glp_production_operations",
      "glp_domestic",
      "glp_cogeneration",
      "glp_combined_kpis",
      "glp_production_operations_kpis",
      "glp_domestic_kpis",
      "glp_cogeneration_kpis",
      "light_fuel_oil_total",
      "light_fuel_oil_total_kpis",
      "heavy_fuel_oil_total",

      "heavy_fuel_oil_total_kpis",
      "biomass_total",
      "steam_total",
    ],

    // Costos (USD, ARS, etc.)
    coins_units: [
      "electricity_cost_total",
      "renewable_energies_ppa_cost",
      "natural_gas_total_cost",
      "heavy_fuel_oil_total_cost",
      "light_fuel_oil_total_cost",
      "coal_total_cost",
      "diesel_total_cost",
      "biodiesel_total_cost",
      "gasoline_total_cost",
      "biofuel_total_cost",
      "biomass_total_cost",
      "steam_total_cost",
      "energy_cost_kpis",
      "glp_total_cost",
      "renewable_energies_on_site_maintenance_and_amortization",
      // Nuevos KPIs de costos
      "total_electricity_cost_kpis",
      "electricity_cost_per_unit_kpis",
      "total_fuels_cost_kpis",
      "total_energy_cost_consumption_kpis",
    ],
  };

  // 🔹 Buscar el grupo donde pertenece `value`
  if (energyGroups.units.includes(value)) return units;
  if (energyGroups.units_1.includes(value)) return units_1;
  if (energyGroups.units_2.includes(value)) return units_2;
  if (energyGroups.units_7.includes(value)) return units_7;
  if (energyGroups.units_4.includes(value)) return units_4;
  if (energyGroups.coins_units.includes(value)) return coins_units;

  // 🔹 Default
  return units;
};

// export const energyCodeToFuente = {
//   // Electricidad estándar
//   electricity_standard_combined: "electricity_standard",
//   electricity_standard_domestic: "electricity_standard",
//   electricity_standard_production: "electricity_standard",
//   electricity_cost_total: "electricity_standard",

//   // Energías Renovables PPA
//   renewable_energies_ppa_combined: "renewable_energies",
//   renewable_energies_ppa_domestic: "renewable_energies",
//   renewable_energies_ppa_production: "renewable_energies",
//   renewable_energies_ppa_cost: "renewable_energies",
//   renewable_energies_ppa_domestic_kpis: "renewable_energies",
//   renewable_energies_ppa_production_kpis: "renewable_energies",
//   renewable_energies_on_site_combined_kpis: "renewable_energies",
// renewable_energies_ppa_cost_kpis: "renewable_energies",
// renewable_energies_ppa_combined_kpis:"renewable_energies",

//   // Energías renovables producidas en el sitio
//   renewable_energies_on_site_combined: "renewable_energies",
//   renewable_energies_on_site_domestic: "renewable_energies",
//   renewable_energies_on_site_production: "renewable_energies",
//   renewable_energies_on_site_maintenance_and_amortization: "renewable_energies",

//   // Gas Natural
//   natural_gas_combined: "natural_gas",
//   natural_gas_cogeneration: "natural_gas",
//   natural_gas_production_operations: "natural_gas",
//   natural_gas_domestic: "natural_gas",
//   natural_gas_total_cost: "natural_gas",

//   // GLP
//   glp_combined: "glp",
//   glp_cogeneration: "glp",
//   glp_production_operations: "glp",
//   glp_domestic: "glp",
//   glp_total_cost: "glp",

//   // Heavy Fuel Oil
//   heavy_fuel_oil_total: "heavy_fuel_oil",
//   heavy_fuel_oil_total_cost: "heavy_fuel_oil",

//   // Light Fuel Oil
//   light_fuel_oil_total: "light_fuel_oil",
//   light_fuel_oil_total_cost: "light_fuel_oil",

//   // Carbón
//   coal_total: "coal",
//   coal_total_cost: "coal",

//   // Diesel
//   diesel_combined: "diesel",
//   diesel_cogeneration: "diesel",
//   diesel_production_operations: "diesel",
//   diesel_forklifts: "diesel",
//   diesel_total_cost: "diesel",

//   // Biodiesel
//   biodiesel_combined: "biodiesel",
//   biodiesel_cogeneration: "biodiesel",
//   biodiesel_production_operations: "biodiesel",
//   biodiesel_forklifts: "biodiesel",
//   biodiesel_total_cost: "biodiesel",

//   // Gasolina / Fuel Oil
//   gasoline_combined: "gasoline",
//   gasoline_cogeneration: "gasoline",
//   gasoline_production_operations: "gasoline",
//   gasoline_forklifts: "gasoline",
//   gasoline_total_cost: "gasoline",

//   // Biocombustible
//   biofuel_combined: "biofuel",
//   biofuel_cogeneration: "biofuel",
//   biofuel_production_operations: "biofuel",
//   biofuel_forklifts: "biofuel",
//   biofuel_total_cost: "biofuel",

//   // Biomasa
//   biomass_total: "biomass",
//   biomass_total_cost: "biomass",

//   // Vapor
//   steam_total: "steam",
//   steam_total_cost: "steam",
// };

// Factores específicos kg ↔ ton por fuente energética
const conversionesKgATonPorFuente = {
  heavy_fuel_oil: 0.01314,
  light_fuel_oil: 0.01163,
  coal: 0.01214,
  diesel: 0.00466,
  biodiesel: 0.012,
  gasoline: 0.012, // aplicable con porcentaje
  biomass: 0.01239, // aplicable con porcentaje
  vapor: 0.00168,
};

/**
 * Convierte entre unidades de masa, volumen o energía, considerando factores específicos por fuente.
 * @param {number} valor - Valor a convertir
 * @param {string} unita - Unidad de origen
 * @param {string} unitb - Unidad de destino
 * @param {string|null} fuente - Fuente energética (opcional)
 * @param {number} porcentaje - Porcentaje a aplicar en casos de Gasolina/Biomasa (default 100)
 */
export function convertUnitsEnergy(
  valor,
  unita,
  unitb,
  fuente = null,
  porcentaje = 100,
) {
  unita = unita?.toLowerCase?.() ?? unita;
  unitb = unitb?.toLowerCase?.() ?? unitb;
  const valorFuente = fuente ? findEnergyFuente(fuente) : null;

  const esMasa = (u) =>
    ["g", "kg", "lb", "oz", "ton (métrica)", "ton (corta)"].includes(u);
  const esVolumen = (u) => ["m3", "l", "us gallons"].includes(u);
  const esEnergia = (u) =>
    ["GJ", "kWh", "MJ", "mmbtu", "btu", "J", "MWh"].includes(u);

  const fuentesSoloEnergia = ["renewable_energies"];

  // --- Energía → Energía ---
  if (esEnergia(unita) && esEnergia(unitb)) {
    return (valor * conversionesEnergia[unita]) / conversionesEnergia[unitb];
  }

  // --- Masa → Masa ---
  if (esMasa(unita) && esMasa(unitb)) {
    const valorEnGramos = valor * conversionesMasa[unita];
    return valorEnGramos / conversionesMasa[unitb];
  }

  // --- Volumen → Volumen ---
  if (esVolumen(unita) && esVolumen(unitb)) {
    const valorEnM3 = valor * conversionesVolumen[unita];
    return valorEnM3 / conversionesVolumen[unitb];
  }

  // --- Volumen/Masa → Energía ---
  if ((esVolumen(unita) || esMasa(unita)) && esEnergia(unitb)) {
    if (!valorFuente) return null;

    const fuenteInfo = fuentesEnergia[valorFuente];
    if (!fuenteInfo) return null;

    const densidad = fuenteInfo.densidad || 1;
    const poderCalorifico = fuenteInfo.poder_calorifico || 0;

    let masaKg = esVolumen(unita) ? valor * densidad : valor;
    let energiaMWh = masaKg * poderCalorifico; // ya en MWh base si tu dataset está así

    // conversión al destino
    switch (unitb) {
      case "MJ":
        return energiaMWh * 3600;
      case "GJ":
        return energiaMWh * 3.6;
      case "kWh":
        return energiaMWh * 1000;
      default:
        return energiaMWh;
    }
  }

  // --- Masa ↔ Volumen ---
  if (
    (esMasa(unita) && esVolumen(unitb)) ||
    (esVolumen(unita) && esMasa(unitb))
  ) {
    if (!valorFuente) return null;
    const densidad = fuentesEnergia[valorFuente]?.densidad || 1;

    if (esMasa(unita)) return valor / densidad;
    if (esVolumen(unita)) return valor * densidad;
  }

  return null;
}

export const convertUnitsFinal = (value, unita, unitb, material = "") => {
  try {
    const esMoneda = (unidad) =>
      coins_units.some((moneda) => moneda.value === unidad);

    // Si las unidades de origen y destino son iguales, no hacer conversión
    if (!value) {
      return 0;
    } else {
      if (unita === unitb) {
        return value;
      }

      // Si estamos trabajando con monedas, aplicamos la conversión de divisas
      if (esMoneda(unita) && esMoneda(unitb)) {
        return value;
      }

      // Si no es moneda, intentamos usar la librería 'convert'
      const result = convert(value).from(unita).to(unitb);
      // Si la conversión falla y devuelve NaN, vamos a intentar con la función personalizada
      if (isNaN(result)) {
        //console.log('La librería convert-units no pudo realizar la conversión. Intentando con la función personalizada...');
        const result2 = convertEnergy2(value, unita, unitb, material);

        return result2;
        //return value;
      }
      return result;
    }
  } catch (error) {
    try {
      const result2 = convertEnergy2(value, unita, unitb, material);
      //console.log(unita,unitb,material,result2)
      return result2;
    } catch {
      // Si ocurre un error en la librería o en la función personalizada, lo capturamos
      console.error(`Error de conversión: ${error.message}`);
      return null; // Retornamos null si hay un error
    }
  }
};

// Función de conversión de masa o volumen a energía
function convertirEnergia(valor, unidad, fuente, destino) {
  const fuenteInfo = fuentesEnergia[fuente];

  if (!fuenteInfo) {
    return "Fuente de energía no encontrada";
  }

  // Obtener el poder calorífico de la fuente energética (en MWh/kg o MWh/kWh)
  let poderCalorificoMWh = fuenteInfo.poder_calorifico;

  // Calcular la energía en MWh
  let energiaMWh = valor * poderCalorificoMWh;

  // Si el destino es kWh, convertir MWh a kWh
  if (destino === "kWh") {
    return energiaMWh * 1000; // 1 MWh = 1000 kWh
  }

  return energiaMWh; // Retorna en MWh
}

/// ------------------------------------------
// 🔹 MAPEO CODE → FUENTE DE ENERGÍA
// ------------------------------------------
export const energyCodeToFuente = {
  electricity_standard_combined: "electricity_standard",
  electricity_standard_domestic: "electricity_standard",
  electricity_standard_production: "electricity_standard",
  electricity_cost_total: "electricity_standard",

  renewable_energies_ppa_combined: "renewable_energies",
  renewable_energies_ppa_domestic: "renewable_energies",
  renewable_energies_ppa_production: "renewable_energies",
  renewable_energies_ppa_cost: "renewable_energies",
  renewable_energies_ppa_domestic_kpis: "renewable_energies",
  renewable_energies_ppa_production_kpis: "renewable_energies",
  renewable_energies_on_site_combined_kpis: "renewable_energies",
  renewable_energies_ppa_cost_kpis: "renewable_energies",
  renewable_energies_ppa_combined_kpis: "renewable_energies",

  renewable_energies_on_site_combined: "renewable_energies",
  renewable_energies_on_site_domestic: "renewable_energies",
  renewable_energies_on_site_production: "renewable_energies",
  renewable_energies_on_site_maintenance_and_amortization: "renewable_energies",

  natural_gas_combined: "natural_gas",
  natural_gas_cogeneration: "natural_gas",
  natural_gas_production_operations: "natural_gas",
  natural_gas_domestic: "natural_gas",
  natural_gas_total_cost: "natural_gas",

  glp_combined: "glp",
  glp_cogeneration: "glp",
  glp_production_operations: "glp",
  glp_domestic: "glp",
  glp_total_cost: "glp",

  heavy_fuel_oil_total: "heavy_fuel_oil",
  heavy_fuel_oil_total_cost: "heavy_fuel_oil",

  light_fuel_oil_total: "light_fuel_oil",
  light_fuel_oil_total_cost: "light_fuel_oil",

  coal_total: "coal",
  coal_total_cost: "coal",

  diesel_combined: "diesel",
  diesel_cogeneration: "diesel",
  diesel_production_operations: "diesel",
  diesel_forklifts: "diesel",
  diesel_total_cost: "diesel",

  biodiesel_combined: "biodiesel",
  biodiesel_cogeneration: "biodiesel",
  biodiesel_production_operations: "biodiesel",
  biodiesel_forklifts: "biodiesel",
  biodiesel_total_cost: "biodiesel",

  gasoline_combined: "gasoline",
  gasoline_cogeneration: "gasoline",
  gasoline_production_operations: "gasoline",
  gasoline_forklifts: "gasoline",
  gasoline_total_cost: "gasoline",

  biofuel_combined: "biofuel",
  biofuel_cogeneration: "biofuel",
  biofuel_production_operations: "biofuel",
  biofuel_forklifts: "biofuel",
  biofuel_total_cost: "biofuel",

  biomass_total: "biomass",
  biomass_total_cost: "biomass",

  steam_total: "steam",
  steam_total_cost: "steam",

  total_energy_kpis: "electricity_standard",
};

// ------------------------------------------
// 🔹 BUSCA FUENTE (exacta o parcial)
// ------------------------------------------
export function findEnergyFuente(code) {
  if (!code) return null;

  const lower = code.toLowerCase();
  // búsqueda exacta
  if (energyCodeToFuente[lower]) return energyCodeToFuente[lower];

  // búsqueda parcial (por includes)
  const found = Object.entries(energyCodeToFuente).find(([key]) =>
    lower.includes(key.replace(/_kpis$/, "")),
  );

  return found ? found[1] : null;
}

// ------------------------------------------
// 🔹 CONVERSIÓN A MWh
// ------------------------------------------
export function convertToMWh(amount, unit, code) {
  const fuente = findEnergyFuente(code);
  if (!fuente) return null; //  si no hay fuente, no hace nada

  // const DATA = {
  //   electricity_standard: { calorific: null, density: null },
  //   renewable_energies: { calorific: null, density: null },
  //   natural_gas: { density: 0.7, calorific: 48 },
  //   glp: { density: 0.54, calorific: 47.3 },
  //   heavy_fuel_oil: { density: 1, calorific: 40 },
  //   light_fuel_oil: { density: 1, calorific: 43 },
  //   coal: { density: 1, calorific: 25.8 },
  //   diesel: { density: 0.84, calorific: 43 },
  //   biodiesel: { density: 0.84, calorific: 43 },
  //   gasoline: { density: 0.74, calorific: 44.3 },
  //   biofuel: { density: 0.74, calorific: 44.3 },
  //   biomass: { density: 1, calorific: 15.6 },
  //   steam: { density: 1, calorific: 1 },
  // };

  const fuel = DATA[fuente];
  if (!fuel && !["kwh", "mwh"].includes(unit?.toLowerCase())) return null;

  const MJ_PER_KWH = 3.6;
  const u = unit?.toLowerCase?.();

  // 🔹 Electricidad directa
  if (u === "mwh") return amount;
  if (u === "kwh") return amount / 1000;

  // 🔹 Combustibles
  const { density, calorific } = fuel || {};
  let mj = 0;

  switch (u) {
    case "kg":
      mj = amount * calorific;
      break;
    case "t":
    case "tn":
      mj = amount * 1000 * calorific;
      break;
    case "l":
    case "litro":
    case "litros":
      mj = amount * density * calorific;
      break;
    case "m3":
      mj = amount * density * calorific;
      break;
    default:
      return null; //  unidad no reconocida → no devuelve nada
  }

  const mwh = mj / 3600;
  return mwh;
}
